import { useCallback } from "react";
import { ContactIcon as UserIcon, FavoriteStarFillIcon } from "@fluentui/react-icons-mdl2";
import { useDispatch, useSelector } from "react-redux";

import { selectActiveProject } from "Store/Selectors/Projects";
import { updateProjectItem } from "Utils/Item";
import { projectsUpdateStart } from "Store/Actions";
import { IContact } from "Model/Storage/IContact";
import { useAuthenticationPreflight } from "Components/Generic/Authentication";
import { useContactIconStyles } from "./UseContactIconStyles";
import { IContactIconProps } from "./IContactIconProps";

export function ContactIcon(props: IContactIconProps): JSX.Element {
  const { contact } = props;
  const { preflightAuthentication } = useAuthenticationPreflight();
  const isRelevant = contact[`@isRelevant`];
  const dispatch = useDispatch();
  const project = useSelector(selectActiveProject);
  const styles = useContactIconStyles();

  const onIsRelevantClick = useCallback(async () => {
    const updatedProject = updateProjectItem(project, contact[`@id`], (c: IContact) => {
      // eslint-disable-next-line no-param-reassign
      c[`@isRelevant`] = !isRelevant;
      return c;
    });
    await preflightAuthentication();
    dispatch(projectsUpdateStart([updatedProject]));
  }, [contact, dispatch, isRelevant, preflightAuthentication, project]);

  return (
    <div onClick={onIsRelevantClick} className={styles.stack}>
      <UserIcon className={styles.userIcon} />
      {contact[`@isRelevant`] ? <FavoriteStarFillIcon className={styles.favoriteIcon} /> : null}
    </div>
  );
}
